/** Közös felületi elemek. Szándékosan kevés, és mind egy fájlban. */

import type { ComponentChildren, JSX } from "preact";

export function Pill({
  tone = "muted",
  children,
}: {
  tone?: string;
  children: ComponentChildren;
}): JSX.Element {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}

export function Card({
  title,
  hint,
  actions,
  children,
}: {
  title?: string;
  hint?: string;
  actions?: ComponentChildren;
  children: ComponentChildren;
}): JSX.Element {
  return (
    <section className="card">
      {(title || actions) && (
        <header className="card__head">
          <div>
            {title && <h2>{title}</h2>}
            {hint && <p className="muted">{hint}</p>}
          </div>
          {actions && <div className="card__actions">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}

export function Stat({
  label,
  value,
  hint,
  tone,
}: {
  label: string;
  value: string;
  hint?: string;
  tone?: string;
}): JSX.Element {
  return (
    <div className={`stat${tone ? ` stat--${tone}` : ""}`}>
      <span className="stat__label">{label}</span>
      <strong className="stat__value">{value}</strong>
      {hint && <span className="stat__hint">{hint}</span>}
    </div>
  );
}

/**
 * Üres állapot.
 *
 * Az üres lista nem hiba, és nem is szabad hibaként hatnia. A szöveg
 * megmondja, MIÉRT üres és mi a teendő — a puszta „nincs adat” a
 * felhasználót magára hagyja.
 */
export function Empty({ children }: { children: ComponentChildren }): JSX.Element {
  return <p className="empty">{children}</p>;
}

export function ErrorNote({ children }: { children: ComponentChildren }): JSX.Element {
  return <p className="notice notice--bad">{children}</p>;
}

export function Loading(): JSX.Element {
  return <p className="muted">Betöltés…</p>;
}

export function Button({
  onClick,
  disabled,
  tone = "",
  children,
}: {
  onClick: () => void;
  disabled?: boolean;
  tone?: string;
  children: ComponentChildren;
}): JSX.Element {
  return (
    <button
      type="button"
      className={`btn${tone ? ` btn--${tone}` : ""}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
